import React from 'react';

import { PageContainer } from './InteractivePageLayout.styles';

export interface InteractivePageLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export const InteractivePageLayout: React.FC<InteractivePageLayoutProps> = ({
  children,
  className,
}) => {
  return <PageContainer className={className}>{children}</PageContainer>;
};

export default InteractivePageLayout;
